import { Link } from "react-router-dom";

type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
};

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-start gap-3">
        <span className="w-1.5 h-7 md:h-8 rounded-full bg-accent-500 mt-0.5"></span>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}